package io.jsonize.web.services

import kotlinx.browser.localStorage

// Provide the actual implementation and also set PlatformStorage.default
@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
actual class PlatformStorageImpl : PlatformStorage {
    override suspend fun save(key: String, data: String) {
        localStorage.setItem(key, data)
    }

    override suspend fun load(key: String): String? {
        return localStorage.getItem(key)
    }
}